import { Link, LinkProps } from 'react-router-dom'
import { ComponentProps, ComponentType, FC } from 'react'
import { cn } from 'utilities/StringUtils'

interface Props extends Pick<LinkProps, 'title'> {
  icon: ComponentType<ComponentProps<'svg'>>
  isActive?: boolean
  path: LinkProps['to']
}

export const NestedLink: FC<Props> = ({ title, icon: Icon, path, isActive = false }) => (
  <Link
    to={path}
    title={title}
    className={`${
      isActive ? 'border-violet' : 'border-transparent hover:border-violet/50 dark:text-gray-300'
    } flex items-center space-x-1 border-b-4 p-3`}
  >
    <Icon
      className={cn('flex-shrink-0 w-5 h-5', isActive ? 'text-violet' : 'dark:text-gray-500')}
    />
    <span className="whitespace-nowrap">{title}</span>
  </Link>
)
